import Vuex, { Store } from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export const store: Store<Record<string, never>> = new Vuex.Store({})
